import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import {GetAPIDomain, RefreshToken} from '../../app/modules/auth/redux/AuthCRUD'
import {ApiResponse} from '../../app/infrastracture/ApiClient';

export class ApiClient {

    static async Delete(path: string, data?: any) {
        let domain = (await GetAPIDomain());
        return ApiResponse.Create(await Create().delete(domain + path, { data: data }));
    }

    static async Get(path: string) {
        let domain = (await GetAPIDomain());
        return ApiResponse.Create(await Create().get(domain + path));
    }

    static async Post(path: string, data?: any) {
        let domain = (await GetAPIDomain());
        console.log("Post", domain + path, data)
        return ApiResponse.Create(await Create().post(domain + path, data));
    }

    static async Patch(path: string, data: any) {
        let domain = (await GetAPIDomain());
        return ApiResponse.Create(await CreateWithContentType("application/json-patch+json").patch(domain + path, data));
    }

    static async Download(path: any) {
        let domain = (await GetAPIDomain());
        return await Create().get(domain + path, { responseType: 'blob' });
    }
    
}

export class PublicApiClient {

    static async Get(path: string) {
        let domain = (await GetAPIDomain());
        return ApiResponse.Create(await PublicCreate().get(domain + path));
    }

    static async Post(path: string, data?: any) {
        let domain = (await GetAPIDomain());
        return ApiResponse.Create(await PublicCreate().post(domain + path, data));
    }

}

function PublicCreate() {

    return axios.create({
        headers: {
            Accept: 'application/json, application/xml, text/play, text/html, *.*',
            'Content-Type': 'application/json',
        }
    });

}

function CreateWithContentType(contentType: string) {
    let client = axios.create({
        headers: {
            Accept: 'application/json, application/xml, text/play, text/html, *.*',
            'Content-Type': contentType,
        }
    });

    client.interceptors.request.use(
        (config) => {
            if (localStorage.getItem('access-token-v2')) {
                config.headers.Authorization = 'Bearer ' + localStorage.getItem("access-token-v2")
            }
            return config
        },
        (error) => {
            return Promise.reject(error)
        }
    );

    // Instantiate the interceptor (you can chain it as it returns the axios instance)
    createAuthRefreshInterceptor(client, refreshAuthLogic, {
        statusCodes: [401],
    });

    return client;
}

function Create() {
    return CreateWithContentType('application/json');
}

const refreshAuthLogic = async () => {
    let refresh = await RefreshToken()

    if (refresh) return Promise.resolve()

    return Promise.reject()
}
